import { updateObject } from '../../helpers/utility.helper';
import { initialState } from '../state/sensorDataChart.state';
import sensorDataChartType from '../types/sensorDataChart.type';
import ISensorDataChartState from '../models/ISensorDataChartState';

const getSensorDataChartStart = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            error: null, loading: true, success: false
        })
    });
};

const getSensorDataChartSuccess = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            datas: action.payload,
            error: null,
            loading: false,
            success: true,
        })
    });
};

const getSensorDataChartError = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            error: action.payload,
            success: false,
            loading: false
        })
    });
};

const resetGetSensorDataChartState = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            datas: action.payload,
            error: null,
            success: false,
            loading: false
        })
    });
};

const resetGetSensorDataChartSuccessState = (oldState: ISensorDataChartState, action: any) => {
    return updateObject(oldState, {
        sensorDataChartList: updateObject(oldState.sensorDataChartList, {
            //datas: action.payload,
            error: null,
            success: false,
            loading: false
        })
    });
};

const sensorDataChartReducer = (oldState: ISensorDataChartState = initialState, action: any) => {
    switch (action.type) {
        case sensorDataChartType.GET_SENSOR_DATA_CHART_START: return getSensorDataChartStart(oldState, action);
        case sensorDataChartType.GET_SENSOR_DATA_CHART_SUCCESS: return getSensorDataChartSuccess(oldState, action);
        case sensorDataChartType.GET_SENSOR_DATA_CHART_ERROR: return getSensorDataChartError(oldState, action);
        case sensorDataChartType.RESET_SENSOR_DATA_CHART: return resetGetSensorDataChartState(oldState, action);
        case sensorDataChartType.RESET_SENSOR_DATA_CHART_SUCCESS: return resetGetSensorDataChartSuccessState(oldState, action);
        default: return oldState;
    }
};
export default sensorDataChartReducer;